<template>
  <div class="iDalgo-Card" @click="handleClick" :class="{ 'active': active, 'disabled': disabled }">
    <div class="iDalgo-Card__Picture" :style="{ 'background-image': 'url(' + picture + ')' }">
      <div class="iDalgo-Card__Picture__Whitemark">
        <svgicon name="logo" :original="true"></svgicon>
      </div>
    </div>
    <div class="iDalgo-Card__Content">
      <h4 :class="{ 'min_1': isMin1 }">{{ title }}</h4>
      <b v-if="subTitle">{{ subTitle }}</b>
    </div>
  </div>
</template>

<script>
export default {
  name: 'iDalgo-Card',
  props: {
    picture: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: false
    }
  },
  computed: {
    isMin1 () {
      return this.title.length > 13
    }
  },
  methods: {
    handleClick () {
      if (!this.disabled || this.active) {
        this.active = !this.active
        this.$emit('click', this.active)
      }
    }
  }
}
</script>

<style lang="scss">
.iDalgo-Card {
  display: flex;
  flex-flow: column;
  padding: 0;
  border-radius: 3px;
  width: 140px;
  box-shadow: 0 2px 9px 0 rgba(0,0,0,0.22);
  cursor: pointer;
  overflow: hidden;
  flex-grow: 0;
  margin: 8px;
  transition: all 0.2s;

  &__Picture {
    display: flex;
    padding: 0;
    margin: 0;
    background: #fff center center no-repeat;
    background-size: cover;
    width: 100%;
    height: 140px;
    transition: all 0.2s;
    position: relative;

    &__Whitemark {
      position: absolute;
      top: 0;
      left: 0;
      width: 29px;
      height: 29px;
      background-color: $color2;
      border-radius: 0 0 6px 0;
      opacity: 0;
      transition: all 0.2s;
      display: none; // TODO: remove after Euro
      justify-content: center;
      align-items: center;

      svg {
        width: 12px;
      }
    }
  }

  &__Content {
    padding: 8px 5px;
    background: #fff;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    transition: all 0.2s;
    overflow: hidden;
    height: 50px;
    box-sizing: border-box;

    h4 {
      color: $text_gray;
      margin: 0;
      padding: 0;
      font-family: "source_sans_proregular", sans-serif;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      transition: all 0.2s;
    }

    b {
      color: $text_gray;
      font-family: "source_sans_prolight", sans-serif;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      transition: all 0.2s;
    }

    .min_1 {
      font-size: 13px;
    }
  }

  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  &:hover {
    box-shadow: 0 4px 35px 0 rgba(0,0,0,0.22);
  }

  &.active {
    opacity: 1;
    cursor: pointer;
    box-shadow: 0 4px 35px 0 rgba(0,0,0,0.22);
    .iDalgo-Card__Content {
      background-color: $color3;
      h4, b {
        color: #000;
      }
    }

    .iDalgo-Card__Picture__Whitemark {
      opacity: 1;
    }
  }

  @media (max-width: 450px) {
    width: 100px;
    margin: 6px;

    &__Picture {
      height: 100px;
    }

    &__Content {
      height: 44px;

      h4 {
        line-height: 12px;
        margin-bottom: 4px;
      }

      b {
        line-height: 8px;
      }
    }
  }

  @media (min-width: 360px) and (max-width: 450px) {
    &:nth-of-type(3n + 1) {
      margin-left: 0;
    }
    &:nth-of-type(3n) {
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Card.vue